<template>
  <div>
    <table width="100%" class="table">
      <thead>
        <tr>
          <th>任务ID</th>
          <th>任务名</th>
          <th v-if="role === 'admin'">描述</th>
          <th>创建时间</th>
          <th v-if="role === 'admin'">任务状态</th>
          <th style="width: 140px;">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t of approveTaskList" :key="`task${t.id}`">
          <td>{{ t.id }}</td>
          <td>{{ t.name }}</td>
          <td v-if="role === 'admin'">{{ t.desc }}</td>
          <td>{{ new Date(t.createAt).toLocaleString('chinese', { hour12: false }) }}</td>
          <td v-if="role === 'admin'">{{ statusMap[t.status] }}</td>
          <td>
            <a v-if="role === 'admin'" @click="toEdit(t)">编辑</a>
            <a :class="t.status === 3 || role === 'approver' ? '' : 'disable'" @click="toApprove(t)">审核</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import * as api from '@/api/api.js';
// import { taskStatusMap, taskStatusFilterMap } from '@/config';

export default {
  name: 'ApproveTaskList',
  data() {
    return {
      role: '',
      taskStatusMap: [],
      taskStatusFilterMap: [],
      customerId: '',
      taskStatus: 0,
      finishedExamIds: [],
      examList: [],
      statusMap: {
        0: '未开始',
        2: '进行中',
        3: '进行中',
        4: '已完成',
      },
    };
  },
  props: ['approveTaskList'],
  mounted: function() {
    this.role = this.$store.state.role;
    window.console.log(this.approveTaskList);
  },
  methods: {
    toApprove(task) {
      this.$router.push({ path: `/saapprove/${task.id}` });
    },
    toEdit(task) {
      this.$router.push({ path: `/approvetask/${task.id}/edit` });
    },
  },
};
</script>

<style scoped>
.disable {
  color: #bbbbbb;
}
a {
  color: #5d89c0;
  text-decoration: none;
  display: inline-block;
  margin: 2px 5px;
  cursor: pointer;
}
p {
  display: inline-block;
  margin: 0px 6px;
  vertical-align: top;
}
section {
  display: inline-block;
  width: max-content;
  vertical-align: top;
  padding: 0px 10px;
  color: #595959;
}
section span {
  display: block;
  padding-bottom: 5px;
}
select {
  border: none;
  font-size: 14px;
  font-weight: bold;
  appearance: none;
  outline: none;
}
span.class-info {
  position: relative;
  text-decoration: underline;
  color: #5d89c0;
}
span.class-info:hover + div.class-info {
  visibility: visible;
}
div.class-info {
  background-color: #ffffff;
  padding: 16px 2px;
  width: max-content;
  position: absolute;
  visibility: hidden;
  z-index: 999;
  border: 1px solid #eeeeee;
  color: #5d89c0;
  box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 1);
  border-radius: 0px 0px 5px 5px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
</style>
